import React from 'react';
import { Alert, Box, Tooltip, Typography } from '@mui/material';
/**
 * Shown while staff preview the customer surface. The turn really runs as a PM (allowlist, MCP code
 * path, redaction), so this states that plainly, and the tooltip names the one thing it cannot copy.
 */
export function LivyPreviewBanner(_ref) {
  let companyLabel = _ref.companyLabel;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: "Matches a PM account holder, who sees the whole company. A regular PM limited to assigned portfolios may see less."
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    variant: "outlined",
    role: "status",
    sx: {
      mx: '16px',
      mt: '10px',
      py: 0,
      borderRadius: '10px',
      '& .MuiAlert-message': {
        fontSize: 13
      }
    }
  }, companyLabel ? "Viewing as a customer at ".concat(companyLabel, ". Same tools and data they get.") : 'Pick a company in the switcher to preview what its customers see.'));
}

/** Shown in the resident support view: the turn runs as the resident on the open record, nothing reaches them. */
export function LivyResidentBanner(_ref2) {
  let name = _ref2.name;
  return /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    variant: "outlined",
    role: "status",
    sx: {
      mx: '16px',
      mt: '10px',
      py: 0,
      borderRadius: '10px',
      '& .MuiAlert-message': {
        fontSize: 13
      }
    }
  }, name ? "Viewing as ".concat(name, ".") : 'Viewing as the resident on this record.', " Their records only. Nothing is sent to them.");
}

/** The resident on the open account page, for the resident support view; null off a resident record. */
export const residentPin = (asResident, context) => asResident && context.entityType === 'resident' && context.entityId && context.accountId ? {
  residencyId: context.entityId,
  accountId: context.accountId
} : null;

/** No composer: a resident turn needs a resident to run as. */
export function ResidentEmptyState() {
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: '24px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary",
    align: "center"
  }, "Open a resident's account to chat as them, or pick one on the Livy page."));
}